import $axios from "@/plugins/axios";

/*
  订单支付
  @param {
    order_no: {string} 报刊编号
    trade_type: {string} 设备环境 pc/h5/wechat
  } 
  @return {
    result
  }
*/ 
export const settlement = params => $axios(
  {
    url: "/lv1/wechat/pay",
    data: params,
    method: 'POST',
  },
  {
    loading: true,
    loadingMsg: '正在支付...',
    code_message_show: true,
  },
);
/*
  订单支付
  @param {
    order_no: {string} 订单编号
  } 
  @return {
    result
  }
*/ 
export const payQuery = params => $axios(
  {
    url: "/v1/order/pay_query",
    params,
    method: 'GET',
  },
  {
    loading: true,
    loadingMsg: '正在查询...',
    code_message_show: true,
  },
);

/*
  生成订单
  @param {
    order_no: {string} 报刊编号
    trade_type: {string} 设备环境 pc/h5/wechat
    address_id: {number} 地址 id
  } 
  @return {
    result
  }
*/ 
export const createOrder = params => $axios(
  {
    url: "/v1/order/add",
    data: params,
    method: 'POST',
  },
  {
    loading: true,
    loadingMsg: '正在生成订单...',
    code_message_show: true,
  },
);

/*
  订单列表
  @param {
  } 
  @return {
  }
*/ 
export const queryOrderList = params => $axios(
  {
    url: "/v1/order/lists",
    params,
    method: 'GET',
  },
  {
    loading: true,
    loadingMsg: '正在获取订单列表...',
    code_message_show: true,
  },
);
/*
  获取报刊信息发货信息
  @param {
  } 
  @return {
  }
*/ 
export const queryOrderBookInfo = params => $axios(
  {
    url: "/v1/order/delivery_lists",
    params,
    method: 'GET',
  },
  {
    loading: true,
    loadingMsg: '正在获取发货信息列表...',
    code_message_show: true,
  },
);
/*
  订单详情
  @param {
  } 
  @return {
  }
*/ 
export const queryOrderDetail = params => $axios(
  {
    url: "/v1/order/detail",
    params,
    method: 'GET',
  },
  {
    loading: true,
    loadingMsg: '正在获取订单详情...',
    code_message_show: true,
  },
);
/*
  退款
  @param {
  } 
  @return {
  }
*/ 
export const refundOrder = params => $axios(
  {
    url: "/lv1/wechat/refund",
    data: params,
    method: 'POST',
  },
  {
    loading: true,
    loadingMsg: '正在退款...',
    code_message_show: true,
  },
);
/*
  取消订单
  @param {
  } 
  @return {
  }
*/ 
export const cancelOrder = params => $axios(
  {
    url: "/v1/order/cancel",
    data: params,
    method: 'POST',
  },
  {
    loading: true,
    loadingMsg: '正在取消订单...',
    code_message_show: true,
  },
);
/*
  更换订单配送地址
  @param {
  } 
  @return {
  }
*/ 
export const changeOrderAddress = params => $axios(
  {
    url: "/v1/order/change_address",
    data: params,
    method: 'POST',
  },
  {
    loading: true,
    loadingMsg: '正在更换...',
    code_message_show: true,
  },
);
